/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Mohammad Zaid Alam",
  title: "Hi all, I'm Zaid",
  subTitle: emoji(
    "A passionate Mobile App Developer 🚀 having an experience of building Web and Mobile applications with Flutter / Dart / Swift Ui / Rest Apis / Firebase and some other cool libraries and frameworks."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1ofFdKF_mqscH8WvXkSObnVvC9kK7Ldlu/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/saadpasta",
  linkedin: "https://www.linkedin.com/in/saadpasta/",
  gmail: "alamzaid991@gmail.com",
  gitlab: "https://gitlab.com/saadpasta",
  facebook: "https://www.facebook.com/saad.pasta7",
  medium: "https://medium.com/@saadpasta",
  stackoverflow: "https://stackoverflow.com/users/10422806/saad-pasta",

  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "A Flutter APP DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ Develop highly interactive Front end / User Interfaces for your mobile applications"
    ),
    emoji(
      "⚡ Integration of third party services such as Firebase"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

 softwareSkills: [
  {
    skillName: "Flutter",
    fontAwesomeClassname: "devicon-flutter-plain colored"
  },
  {
    skillName: "Dart",
    fontAwesomeClassname: "devicon-dart-plain colored"
  },
  {
    skillName: "Firebase",
    fontAwesomeClassname: "devicon-firebase-plain colored"
  },
  {
    skillName: "SwiftUI",
    fontAwesomeClassname: "devicon-swift-plain colored"
  },
  {
    skillName: "Node.js",
    fontAwesomeClassname: "fab fa-node-js"
  },
  {
    skillName: "REST API",
    fontAwesomeClassname: "fas fa-network-wired"
  }
],


  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Cathedral Senior Secondary School",
      logo: require("./assets/images/harvardLogo.jpg"),
      subHeader: "High School",
      duration: "Passing year 2017",
      desc: "Scored 7.4 CGPA in my CBSE boards",
      descBullets: [
       
      ]
    },
    {
      schoolName: "Lucknow Christian Degree College",
      logo: require("./assets/images/stanfordLogo.jpg"),
      subHeader: "Bachelor of Science",
      duration: "May 2020 - April 2023",
      // desc: "Ranked top 10% in the program. Took courses about Software Engineering, Web Security, Operating Systems, ...",
      // descBullets: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit"]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Flutter", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Node Js",
      progressPercentage: "30%"
    },
    {
      Stack: "Swift Ui",
      progressPercentage: "50%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section
// companylogo: require("./assets/images/facebookLogo.png"),
//  companylogo: require("./assets/images/quoraLogo.png"),
// companylogo: require("./assets/images/airbnbLogo.png"),
const workExperiences = {
  display: true, // Set it to true to show workExperiences Section
  experience: [
    {
      role: "Senior Flutter Developer",
      company: "Life InfoTech IT Solution",
     companylogo: require("./assets/images/logo.png"),
      date: "Jan 2025 – Present",
      desc: "Working as a Senior Flutter Developer, leading the development of multiple production-ready mobile applications published on the Google Play Store.",
      descBullets: [
        "Shaadi Partners – Wedding vendor booking marketplace with catering, decoration, photography booking using REST APIs, Provider, and Razorpay integration",
        "Admire – OLX-like buy & sell marketplace with product listing, chat, FCM push notifications, and Dark/Light mode support",
        "Grace Food App – Food delivery application with live order tracking, menu browsing, and secure checkout",
        "Furniture E-Commerce App – Online furniture shopping app with product catalog, cart, checkout, and smooth navigation",
        "iLawyer App – Case and client management system for lawyers with reminders and case history tracking",
        "Guru Home Tutors – Platform connecting students and tutors with profile management and class scheduling",
        "SIDCO App – Government/NGO application with modern UI/UX and improved accessibility",
        "Service Management App – Employee attendance and work-tracking system with punch-in/punch-out and monthly reports"
      ]
    },
    {
      role: "Flutter Developer",
      company: "Ndmea Technology",
      companylogo: require("./assets/images/logomain.png"),
      date: "Jun 2023 – Sep 2024",
      desc: "Developed high-performance Flutter applications focusing on gaming, betting platforms, and enterprise attendance systems.",
      descBullets: [
        "Gookki – Gaming and betting application featuring Ludo gameplay and betting workflows",
        "Googly11 – Fantasy cricket app inspired by Dream11 with real-time updates and engaging UI",
        "OAEMS – Employee attendance management system using face detection and machine learning APIs",
        "Integrated Firebase services including Authentication, Firestore, and Push Notifications"
      ]
    },
    {
      role: "Flutter Developer Intern / UI-UX Designer",
      company: "RogPad Technologies",
      companylogo: require("./assets/images/rog.jpg"),
      date: "Nov 2022 – May 2023",
      desc: "Six-month internship focused on Flutter development and UI/UX design with hands-on experience building real-world applications.",
      descBullets: [
        "Designed clean and user-friendly UI/UX using Figma",
        "Developed 2 real-world Flutter applications from scratch",
        "Worked closely with senior developers to understand production-level app architecture"
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/shaadi.webp"),
      projectName: "Shaadi Partners",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
         name: "On PlayStore",
          url: "https://play.google.com/store/apps/details?id=com.shaadi.partners_flutter_master&hl=en_IN"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/ilawyer.webp"),
      projectName: "ILawyer",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
         name: "On PlayStore",
          url: "https://play.google.com/store/apps/details?id=com.lifeinfotech.ilawear_app&hl=en"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/sonika.webp"),
      projectName:  "Sonika Bazaar",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
           name: "On PlayStore",
          url: "https://play.google.com/store/apps/details?id=com.mysonikastore.app&hl=en_IN"
        }
      ]
    },
     {
      image: require("./assets/images/service.webp"),
      projectName: "Service Management",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "On PlayStore",
          url: "https://play.google.com/store/apps/details?id=com.servicemanagement.newapp&hl=en_IN"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/admire.webp"),
      projectName:  "Admire",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "On PlayStore",
          url: "https://play.google.com/store/apps/details?id=com.admire.marketplace&hl=en_IN"
        }
      ]
    },
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
   {
  title: "UI/UX & Flutter Internship (6 Months)",
  subtitle:
    "Completed a 6-month internship focused on UI/UX design using Figma and mobile app development using Flutter. Gained hands-on experience in designing user-friendly interfaces and building real-world applications.",
 image: require("./assets/images/internship.png"), // add image in assets
  imageAlt: "Figma UI UX and Flutter Internship",
  footerLink: [
    {
      name: "Internship Certificate",
      url: "YOUR_FLUTTER_FIGMA_CERTIFICATE_LINK"
    }
  ]
},

    {
  title: "Machine Learning & Data Science Certification",
  subtitle:
    "Completed a 6-month professional course in Machine Learning and Data Science, covering data analysis, model building, and real-world problem solving.",
  image: require("./assets/images/certificate.png"), // add image in assets
  imageAlt: "Machine Learning and Data Science Certificate",
  footerLink: [
    {
      name: "Course Certificate",
      url: "YOUR_ML_DATASCIENCE_CERTIFICATE_LINK"
    }
  ]
}

  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
blogs: [
  {
    url: "https://medium.com/@yourname/flutter-clean-architecture",
    title: "Flutter Clean Architecture for Beginners",
    description:
      "A simple guide to structuring Flutter apps using Clean Architecture with real examples.",
    date: "Jan 2026",
    tags: ["Flutter", "Architecture", "Clean Code"]
  },
  {
    url: "https://medium.com/@yourname/react-navbar",
    title: "Build a Modern Responsive Navbar in React",
    description:
      "Learn how to create a mobile-friendly navbar using React hooks and CSS.",
    date: "Dec 2025",
    tags: ["React", "UI", "Frontend"]
  }
],

  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+91-7860076194",
  email_address: "alamzaid991@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: true // Set true to display this section, defaults to false
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
